import { AlertTriangle, XOctagon } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { Display } from '@/types/api'
import { deriveDisplayPill, TONE_CLASSES } from '../lib/status'
import { HealthDot } from './health-dot'

/** Compact badge: derived status label with a dot, plus a warning/error glyph when health overlays. */
export function ConnectivityBadge({ display, className }: { display: Pick<Display, 'status' | 'connectivity' | 'health'>; className?: string }) {
  const pill = deriveDisplayPill(display)
  const t = TONE_CLASSES[pill.effectiveTone]
  const OverlayIcon = pill.overlay === 'error' ? XOctagon : pill.overlay === 'warning' ? AlertTriangle : null
  return (
    <span
      className={cn('inline-flex w-fit items-center gap-1.5 rounded-full px-2 py-0.5 text-[11.5px] font-medium whitespace-nowrap', t.soft, t.text, className)}
      title={pill.description}
    >
      <HealthDot tone={pill.effectiveTone} size="sm" pulse={false} />
      {pill.label}
      {OverlayIcon && (
        <OverlayIcon className={cn('size-3', pill.overlay === 'error' ? 'text-danger' : 'text-[color-mix(in_oklch,var(--warning),black_30%)] dark:text-warning')} aria-label={pill.overlay ?? undefined} />
      )}
    </span>
  )
}
